<template>
  <div class="edit-upload-img">
        <alart-msg :display="alart.fail" styleType="error" @alartStatus="alart.fail = false">
            <span class="title" slot="title">{{msg.error}}</span>
        </alart-msg>
        <modal class="select-gallery" :display="modal" @modalStatus="closeModal()" >
            <h1>所有內容圖</h1>
            <div class="content">
                <div  class="left">
                    <img v-if="images.length > 0" :src="images[selected].blob" alt="">
                    <div v-if="images.length > 0" class="edit-btn">
                        <div :data-id="images[selected].cid"  @click.prevent="galleryRemove(images[selected])" class="delete">
                            <img src="@/assets/img/icon/trash.svg" alt="">
                            刪除照片
                        </div>
                    </div>
                </div>
                <div class="right">
                    <ul>
                        <li v-for="(image, index) in images" :key="index" :class="{'active': selected == index}" @click="selected = index">
                            <img :src="image.blob" alt="">
                        </li>
                        <li class="list-upload" v-show="images.length != 10" :class="{'drop-active': $refs.upload && $refs.upload.dropActive}">
                            <file-upload
                            class="upload-btn"
                            post-action="/upload/post"
                            :size="1024 * 5"
                            :maximum="uploadImageLimit"
                            :multiple="true"
                            :drop="true"
                            :drop-directory="true"
                            v-model="files"
                            @input-file="inputFile"
                            @input-filter="inputFilter"
                            ref="upload">
                                <img class="upload-icon" src="@/assets/img/icon/upload.svg" alt="">
                            </file-upload>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button" @click="closeModal()">確認</button>
            </div>
        </modal>
        <div class="image-cover">
            <div class="title">封面縮圖</div>
            <div v-if="cover || covers.length > 0"  class="cover-preview" >
                <div  class="preview" :class="{'error': imgChangeCoverError}">
                    <img  :src="coverImg" />
                </div>
                <span v-show="imgChangeCoverError" class="error">請更換預設封面縮圖</span>
                <file-upload
                    class="replace"
                    :class="{'replace-error': imgChangeCoverError}"
                    post-action="/upload/post"
                    input-id="cover"
                    :size="1024 * 5"
                    :maximum="1"
                    :multiple="true"
                    :drop-directory="true"
                    v-model="covers"
                    @input-file="inputCoverFile"
                    @input-filter="inputCoverFilter"
                    ref="uploadCover">
                        取代圖片
                </file-upload>
            </div>
            <div v-else class="cover-block" :class="{'replace-error': imgCoverError || imgChangeCoverError}">
                <file-upload
                class="upload-btn"
                post-action="/upload/post"
                input-id="cover"
                :size="1024 * 5"
                :maximum="1"
                :multiple="true"
                v-model="covers"
                @input-file="inputCoverFile"
                @input-filter="inputCoverFilter"
                ref="uploadCover">
                    <img class="upload-icon" src="@/assets/img/icon/upload.svg" alt="">
                    上傳圖片
                </file-upload>
                <span v-show="imgCoverError" class="error">必填欄位</span>
            </div>
           
        </div>
        <div class="image-content">
            <div class="title">
                內容圖
                <span v-show="imgError" class="error">至少上傳一張圖片</span>
            </div>
            <div  v-if="files.length || images.length" class="has-img">
                <ul>
                    <li v-for="(image, index) in images" :key="index" @mouseenter="fullScreenShow(index)" @mouseleave="fullScreenHide(index)">
                        <div v-show="hover[index]" :key="'c'+componentKey" @click="openGallery(index)" class="full-screen">
                            <img src="@/assets/img/icon/fullscreen.svg" alt="">
                        </div>
                        <div class="preview">
                            <img  :src="image.blob" />
                        </div>
                        <img class="cancel" :data-id="image.cid"  @click.prevent="deletImg(index),$refs.upload.remove(image)" src="@/assets/img/icon/cancel_black.svg" alt="">
                        <span v-if="image.error">{{image.error}}</span>
                    </li>
                    <li class="list-upload" v-show="images.length != 10" :class="{'drop-active': $refs.upload && $refs.upload.dropActive}">
                        <file-upload
                        :key="'a'+uploadImageLimit"
                        class="upload-btn"
                        post-action="/upload/post"
                        :size="1024 * 5"
                        :maximum="uploadImageLimit"
                        :multiple="true"
                        :drop="true"
                        :drop-directory="true"
                        v-model="files"
                        @input-file="inputFile"
                        @input-filter="inputFilter"
                        ref="upload">
                            <img class="upload-icon" src="@/assets/img/icon/upload.svg" alt="">
                            <span class="upload-description">拖放檔案或點擊此區立即上傳</span>
                            <span class="upload-drop-alarm">將圖片拖放到這裡</span>
                        </file-upload>
                    </li>
                </ul>
            </div>
            <div v-else class="no-img" :class="{'drop-active': $refs.upload && $refs.upload.dropActive, 'error': imgError}">
                <!-- <button class="upload-btn">上傳圖片</button> -->
                <file-upload
                :key="'b'+uploadImageLimit"
                class="upload-area"
                post-action="/upload/post"
                :multiple="true"
                :drop="true"
                :drop-directory="true"
                :maximum="uploadImageLimit"
                v-model="files"
                @input-file="inputFile"
                @input-filter="inputFilter"
                ref="upload">
                    <img class="upload-icon" src="@/assets/img/icon/upload.svg" alt="">
                    <span class="upload-description">拖放檔案或點擊此區立即上傳</span>
                    <span class="upload-drop-alarm">將圖片拖放到這裡</span>
                </file-upload>
            </div>
        </div>
        <!-- <div class="has-img">
            <span v-show="imgError" class="error">至少上傳封面照片</span>
            <ul ref="imgList">
                <li v-for="(image, index) in images" :key="index" >
                    <img class="preview" :src="image.blob" />
                    <img class="cancel" :data-id="image.cid" @click.prevent="deletImg(index),$refs.upload.remove(image)" src="../../../../../assets/img/icon/cancel_black.svg" alt="">
                </li>
                <li class="list-upload" v-show="images.length < 9">
                    <img class="upload-icon" src="../../../../../assets/img/icon/upload.svg" alt="">
                    <file-upload
                    class="upload-btn"
                    post-action="/upload/post"
                    :size="1024 * 5"
                    :maximum="9"
                    :multiple="true"
                    :drop="true"
                    :drop-directory="true"
                    v-model="files"
                    @input-file="inputFile"
                    @input-filter="inputFilter"
                    ref="upload">
                    上傳圖片
                    </file-upload>
                </li>
            </ul>
        </div> -->
  </div>
</template>
<script>
import FileUpload from 'vue-upload-component';
import Modal from '@/components/widge/Modal.vue';
import ImgEditCheckbox from '@/components/widge/ImgEditCheckbox.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import constant from '@/constant'
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            componentKey: 0,
            hover: [],
            files: [],
            selected: 0,
            delImg: [],
            cover: '',
            covers: [],
            delCover: false,
            modal: false,
            images: [],
            uploadImageLimit: null,
            alart: {
                success: false,
                fail: false
            },
            msg: {
                success: null,
                error: null,
            },
        }
    },
    mounted (){
        this.cover = this.houseDefault.houseCoverImage
        if(this.houseDefault.houseImageListList){
            for (let i = 0; i < this.houseDefault.houseImageListList.length; i++) {
                const element = this.houseDefault.houseImageListList[i];
                // console.log(this.cover)
                // console.log(element.imageUrl)
                if( this.cover != element.imageUrl){
                    this.images.push({
                        cid: element.imageCid,
                        blob: constant.imageUrl+element.imageUrl})
                }
                // this.images[i] = {
                //     cid: element.imageCid,
                //     blob: constant.imageUrl+element.imageUrl
                // }
            }
            this.uploadImageLimit = (10 - this.images.length)
        }else{
            this.uploadImageLimit = 10
        }
        
    },
    props: {
        imgError: Boolean,
        imgCoverError: Boolean,
        imgChangeCoverError: Boolean,
    },
    watch: {
        files: {
            handler: function (value) {
                this.$store.dispatch('setEditImageFiles', value)
                this.$store.dispatch('setHouseCid', this.houseDefault.houseCid)
            },
            deep: true
        },
        images: {
            handler: function (value) {
                if(value.length > 10){
                    value.pop()
                }
                for (let i = 0; i < value.length; i++) {
                    this.hover[i] = false
                }
                this.uploadImageLimit = (10 - value.length)+this.files.length
            },
            deep: true
        }, 
        covers: {
            handler: function () {
                // console.log(this.covers)
                this.$store.dispatch('setEditImageCovers', this.covers)
                this.$store.dispatch('setHouseCid', this.houseDefault.houseCid)
            },
            deep: true
        },
        delCover: function () {
            this.$store.dispatch('setEditDelCover')
        },
        delImg:{
            handler: function () {
                this.$store.dispatch('setEditDelImage', this.delImg)
                this.$store.dispatch('setHouseCid', this.houseDefault.houseCid)
            },
            deep: true
        },
        // select: function () {
        //     this.$store.dispatch('setCover', this.select)
        // }
        imgError: function () {},
        imgCoverError: function () {},
        imgChangeCoverError: function () {},
    },
    methods: {
        closeModal: function (type) {
            this.modal = false
        },
        fullScreenShow: function (index) {
            this.hover[index] = true
            this.componentKey += 1
        },
        fullScreenHide: function (index) {
            this.hover[index] = false
            this.componentKey += 1
        },
        openGallery: function (index) {
            this.modal = true
            this.selected = index
        },
        galleryRemove: function (file) {
            this.deletImg(this.selected)
            this.$refs.upload.remove(file)
            if(this.selected == 0){
                this.selected = 0
            }else{
                this.selected -= 1
            }
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                // console.log('response', newFile.response)
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.alart.fail = true
                    this.msg.error = '請上傳JPG或PNG檔案'
                    return prevent()
                }
                if(newFile.size > (1024*1024*5)){
                    this.alart.fail = true
                    this.msg.error = '檔案最大限制5MB'
                    return prevent()
                }
            }
            // console.log(newFile)
            if( newFile != undefined){
                this.images.push(newFile)
            }
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        inputCoverFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                // console.log('response', newFile.response)
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputCoverFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.alart.fail = true
                    this.msg.error = '請上傳JPG或PNG檔案'
                    return prevent()
                }
                if(newFile.size > (1024*1024*5)){
                    this.alart.fail = true
                    this.msg.error = '檔案最大限制5MB'
                    return prevent()
                }
            }
            // console.log(newFile)
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        imageUrl: function (url) {
            return constant.imageUrl+url
        },
        deletImg: function (index) {
            if(event.target.dataset.id){
                this.delImg.push(event.target.dataset.id)
            }
            // console.log(index)
            this.images.splice(index, 1);
        }
    },
    computed: {
        coverImg: function () {
            if( this.covers.length > 0){
                return this.covers[0].blob
            }else if( this.cover ){
                return constant.imageUrl+this.cover
            }
        },
        // uploadImageLimit: function () {
        //     return 10 - this.images.length
        // },
        ...mapGetters({
            houseDefault: 'GET_EDIT_HOUSE_DEFAULT',
        })
    },
    components: {
        FileUpload,
        Modal,
        ImgEditCheckbox,
        AlartMsg,

    },
}
</script>
<style lang="scss" scoped>
    .edit-upload-img{
        position: relative;
        margin-bottom: 40px;
        .title{
            position: relative;
            margin-bottom: 12px;
            .error{
                top: unset;
            }
        }
        .image-cover{
            margin-bottom: 30px;
            .cover-block{
                position: relative;
                width: 124px;
                height: 93px;
                border-radius: 4px;
                border: dashed 1px #cacfcd;
                background-color: #ffffff;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                img{
                    width: 15px;
                    margin-bottom: 8px;
                }
                .upload-btn{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }
                .error{
                    position: absolute;
                    width: 200px;
                    left: 136px;
                    top: unset;
                }
            }
            .cover-block.error{
                border: dashed 1px #fc7171;
            }
            .cover-preview{
                display: flex;
                align-items: center;
                .preview{
                    position: relative;
                    width: 124px;
                    height: 93px;
                    display: flex;
                    margin-right: 16px;
                    align-items: center;
                    border-radius: 4px;
                    overflow: hidden;
                    >img{
                        width: 100%;
                    }
                }
                .preview.error{
                    border: solid 1px #fc7171;
                    
                }
                span.error{
                    top: 39px;
                    left: 144px;
                }
                .replace{
                    width: 104px;
                    height: 44px;
                    border-radius: 4px;
                    border: solid 1px #e0dfde;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .replace-error{
                    top: 13px;
                }
            }
        }
        .no-img.error{
            border: dashed 1px #fc7171;
        }
        .no-img{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 1154px;
            height: 166px;
            margin-bottom: 30px;
            border-radius: 2px;
            border: dashed 1px #cacfcd;
            background-color: #ffffff;
            box-sizing: border-box;
            .upload-area{
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                .upload-icon{
                    margin-bottom: 20px;
                }
            }
            .upload-warm{
                margin-top: 10px;
                color: #a8a5a4;
            }
            .upload-drop-alarm{
                display: none;
            }
        }
        .no-img.drop-active{
            border: solid 1px #ff9275;
            background-color: #fff4f1;
            .upload-btn,
            .upload-icon,
            .upload-description,
            .upload-warm{
                display: none;
            }
            .upload-drop-alarm{
                display: block;
                font-weight: 500;
                color: #ff9275;
            }
        }
        .has-img{
            ul{
                display: flex;
                flex-wrap: wrap;
                li{
                    position: relative;
                    margin-right: 17px;
                    margin-bottom: 13px;
                    cursor: pointer;
                    .full-screen{
                        position: absolute;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        height: 100%;
                        border-radius: 4px;
                        background-color: rgba(32, 35, 34, 0.8);
                    }
                    .preview{
                        width: 124px;
                        height: 93px;
                        display: flex;
                        align-items: center;
                        border-radius: 4px;
                        overflow: hidden;
                        >img{
                            width: 100%;
                        }
                    }
                    .cancel{
                        position: absolute;
                        cursor: pointer;
                        top: -14px;
                        right: -14px;
                    }
                    
                }
                li:nth-child(8n){
                    margin-right: 0px;
                }
                .list-upload{
                    width: 264px;
                    height: 93px;
                    border-radius: 4px;
                    border: dashed 1px #cacfcd;
                    background-color: #ffffff;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    img{
                        width: 15px;
                        margin-bottom: 8px;
                    }
                    .upload-btn{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }
                    .upload-drop-alarm{
                        display: none;
                    }
                }
                .list-upload.drop-active{
                    border: solid 1px #ff9275;
                    background-color: #fff4f1;
                    .upload-icon,
                    .upload-description,
                    .upload-warm{
                        display: none;
                    }
                    .upload-drop-alarm{
                        display: block;
                        font-weight: 500;
                        color: #ff9275;
                    }
                    
                }
            }
        }
        .select-gallery{
            .modal-content{
                width: 742px;
                height: 600px;
                padding: 0 !important;
                .detail{
                    align-items: flex-start !important;
                    h1{
                        margin: 32px auto;
                    }
                    .content{
                        padding: 0 32px;
                        overflow-x: hidden;
                        display: flex;
                        margin-bottom: 15px;
                        .left{
                            position: relative;
                            width: 540px;
                            height: 405px;
                            margin-right: 12px;
                            display: flex;
                            align-items: center;
                            border-radius: 4px;
                            overflow: hidden;
                            >img{
                                width: 100%;
                            }
                            .edit-btn{
                                position: absolute;
                                display: flex;
                                bottom: 20px;
                                left: 20px;
                                .replace,
                                .delete{
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    width: 130px;
                                    height: 54px;
                                    border-radius: 4px;
                                    background: #fff;
                                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                                    margin-right: 20px;
                                    img{
                                        margin-right: 4px;
                                    }
                                }
                            }
                        }
                        .right{
                            ul{
                                display: flex;
                                flex-direction: column;
                                height: 405px;
                                width: 100px;
                                flex-wrap: wrap;
                                li{
                                    width: 53px;
                                    height: 40px;
                                    display: flex;
                                    align-items: center;
                                    margin-bottom: 10px;
                                    border-radius: 1px;
                                    overflow: hidden;
                                    box-sizing: border-box;
                                    margin-right: 10px;
                                    >img{
                                        width: 100%;
                                    }
                                }
                                li.active{
                                    border: solid 2px #ff9275;
                                }
                                li.list-upload{
                                    border-radius: 4px;
                                    border: dashed 1px #cacfcd;
                                    background-color: #ffffff;
                                    display: flex;
                                    flex-direction: column;
                                    align-items: center;
                                    justify-content: center;
                                    img{
                                        width: 15px;
                                    }
                                }
                            }
                        }
                    }
                    .content::-webkit-scrollbar {
                        display: none;
                    }
                }
                
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .upload-img{
            .no-img{
                width: 1142px;
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/landlord/houseStatus/houseManagement/addHouse/EditImg.vue